// Layout
import { AuthLayout } from '@zolteam/zol-admin-ui';
// Views
import Login from '../../views/cortizol/auth/Login';
import ForgotPassword from '../../views/cortizol/auth/ForgotPassword';
import ResetPassword from '../../views/cortizol/auth/ResetPassword';
import EmailConfirmed from '../../views/cortizol/auth/EmailConfirmed';
import ContentTypeForm from '../../views/cortizol/contents/ContentTypeForm/ContentTypeForm';
import ContentTypeList from '../../views/cortizol/contents/ContentTypeList';
import MediaList from '../../views/cortizol/medialibrary/MediaList';
import MediaForm from '../../views/cortizol/medialibrary/MediaForm';
import ErrorFallback from '../../views/ErrorFallback';
// Components
import permissions from '../../permissions/permissionManagement';
import ProtectedRoute from '../ProtectedRoute';

/**
 *  @type {Route[]}
 */
export const cortizolPrivateRoutes = [
  // Contents
  {
    path: '/content/:contentTypeId/:contentId',
    element: (
      <ProtectedRoute permissions={permissions.contentTypeForm.accessContentTypeFormView}>
        <ContentTypeForm />
      </ProtectedRoute>
    ),
    errorElement: <ErrorFallback />,
  },
  {
    path: '/content/:contentTypeId/',
    element: (
      <ProtectedRoute permissions={permissions.contentTypeList.accessContentTypeView}>
        <ContentTypeList />
      </ProtectedRoute>
    ),
    errorElement: <ErrorFallback />,
  },
  // Media
  {
    path: '/media',
    element: (
      <ProtectedRoute permissions={permissions.mediaList.accessMediaListView}>
        <MediaList />
      </ProtectedRoute>),
    errorElement: <ErrorFallback />,
  },
  {
    path: '/media/:id',
    element: (
      <ProtectedRoute permissions={permissions.mediaEdit.accessMediaEditView}>
        <MediaForm />
      </ProtectedRoute>
    ),
    errorElement: <ErrorFallback />,
  },
];
/**
 *  @type {Route[]}
 */
export const cortizolPublicRoutes = [
  // Auth
  {
    path: '/login',
    element: <AuthLayout><Login /></AuthLayout>,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/ask-reset-password',
    element: <AuthLayout><ForgotPassword /></AuthLayout>,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/reset-password',
    element: <AuthLayout><ResetPassword /></AuthLayout>,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/confirm-password',
    element: <AuthLayout><EmailConfirmed /></AuthLayout>,
    errorElement: <ErrorFallback />,
  },
];
